import { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { LeaderboardWithResults } from '../models/LeaderboardWithResults';
import driverApi from '../clients/DriverClient';
import siteApi from '../clients/SiteClient';
import ResultsTable from './shared/ResultsTable';
import EmptyState from './EmptyState';


const Leaderboard = () => {
    const { id, type } = useParams<{ id: string, type: string }>();
    const [searchParams] = useSearchParams();
    const [results, setResults] = useState<LeaderboardWithResults | null>(null);
    const [isLoading, setIsLoading] = useState(false);

    const days = searchParams.get('days');
    const count = searchParams.get('count');

    useEffect(() => {
        const fetchData = async () => {
            if (!id) return;
            try {
                let data;
                setIsLoading(true);
                if (type) {
                    data = await siteApi.getLeaderboardById(type, id, days, count);
                } else {
                    data = await driverApi.getLeaderboardById(id, days, count);
                }
                setResults(data);
            } catch (error) {
                console.error("Fetch error:", error);
            }
            finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [id, days, count, type]);

    return (
        <main>
            <article>
                {isLoading ? (
                    <EmptyState message="Loading leaderboard..." animate={true} />
                ) : (
                    <ResultsTable results={results} type={type} />
                )}
            </article>
        </main>
    );
};

export default Leaderboard;
